export const RECEIVED_HRMS32E_DETAIL_INDEX = 'RECEIVED_HRMS32E_DETAIL_INDEX'
export const RECEIVED_HRMS32E_DETAIL_TOPIC = 'RECEIVED_HRMS32E_DETAIL_TOPIC'
export const RECEIVED_HRMS32E_DETAIL_TAB1 = 'RECEIVED_HRMS32E_DETAIL_TAB1'
export const RECEIVED_HRMS32E_DETAIL_TAB2_6 = 'RECEIVED_HRMS32E_DETAIL_TAB2_6'

export const GET_HRMS32E_MAX_ROWSPAN = 'GET_HRMS32E_MAX_ROWSPAN'
export const SET_HRMS32E_COLUMNS = 'SET_HRMS32E_COLUMNS'
export const GET_HRMS32E_COLUMNS = 'GET_HRMS32E_COLUMNS'
// export const RECEIVED_HRMS32E_COLUMNS_LABELS = 'RECEIVED_HRMS32E_COLUMNS_LABELS'
export const SET_HRMS32E_LABELS = 'SET_HRMS32E_LABELS'
export const GET_HRMS32E_LABELS = 'GET_HRMS32E_LABELS'
// export const RECEIVED_HRMS32E_DROPDOWNS = 'RECEIVED_HRMS32E_DROPDOWNS'
export const SET_HRMS32E_DROPDOWNS = 'SET_HRMS32E_DROPDOWNS'
export const SET_HRMS32E_DROPDOWNS2 = 'SET_HRMS32E_DROPDOWNS2'
export const GET_HRMS32E_DROPDOWNS = 'GET_HRMS32E_DROPDOWNS'
export const RECEIVED_HRMS32E_DROPDOWNS_COLUMNS_LABELS = 'RECEIVED_HRMS32E_DROPDOWNS_COLUMNS_LABELS'
export const RECEIVED_HRMS32E_DROPDOWNS2 = 'RECEIVED_HRMS32E_DROPDOWNS2'

export const SET_HRMS32E_DETAIL_INDEX = 'SET_HRMS32E_DETAIL_INDEX'
export const GET_HRMS32E_DETAIL_INDEX = 'GET_HRMS32E_DETAIL_INDEX'
export const SET_HRMS32E_DETAIL_TOPIC = 'SET_HRMS32E_DETAIL_TOPIC'
export const GET_HRMS32E_DETAIL_TOPIC = 'GET_HRMS32E_DETAIL_TOPIC'
export const SET_HRMS32E_DETAIL_TAB1 = 'SET_HRMS32E_DETAIL_TAB1'
export const GET_HRMS32E_DETAIL_TAB1 = 'GET_HRMS32E_DETAIL_TAB1'
export const SET_HRMS32E_DETAIL_TAB2 = 'SET_HRMS32E_DETAIL_TAB2'
export const GET_HRMS32E_DETAIL_TAB2 = 'GET_HRMS32E_DETAIL_TAB2'
export const SET_HRMS32E_DETAIL_TAB3 = 'SET_HRMS32E_DETAIL_TAB3'
export const GET_HRMS32E_DETAIL_TAB3 = 'GET_HRMS32E_DETAIL_TAB3'
export const SET_HRMS32E_DETAIL_TAB4 = 'SET_HRMS32E_DETAIL_TAB4'
export const GET_HRMS32E_DETAIL_TAB4 = 'GET_HRMS32E_DETAIL_TAB4'
export const SET_HRMS32E_DETAIL_TAB5 = 'SET_HRMS32E_DETAIL_TAB5'
export const GET_HRMS32E_DETAIL_TAB5 = 'GET_HRMS32E_DETAIL_TAB5'
export const SET_HRMS32E_DETAIL_TAB6 = 'SET_HRMS32E_DETAIL_TAB6'
export const GET_HRMS32E_DETAIL_TAB6 = 'GET_HRMS32E_DETAIL_TAB6'

export const DELETE_HRMS32E_DOCUMENTS = 'DELETE_HRMS32E_DOCUMENTS'
export const DELETE_HRMS32E_EDUCATION = 'DELETE_HRMS32E_EDUCATION'
export const DELETE_HRMS32E_CHILD_DATA = 'DELETE_HRMS32E_CHILD_DATA'
export const DELETE_HRMS32E_TRAINING_DATA = 'DELETE_HRMS32E_TRAINING_DATA'

export const GET_HRMS32E_INDEX = 'GET_HRMS32E_INDEX'
export const SET_HRMS32E_INDEX = 'SET_HRMS32E_INDEX'
export const RECEIVED_HRMS32E_INDEX = 'RECEIVED_HRMS32E_INDEX'
export const GET_HRMS32E_INDEX_SELECTED = 'GET_HRMS32E_INDEX_SELECTED'
export const SET_HRMS32E_INDEX_SELECTED = 'SET_HRMS32E_INDEX_SELECTED'

export const POST_HRMS32E_DETAIL1_SAVE = 'POST_HRMS32E_DETAIL1_SAVE'
export const POST_HRMS32E_DETAIL2_TAB1_SAVE = 'POST_HRMS32E_DETAIL2_TAB1_SAVE'
export const POST_HRMS32E_DETAIL2_TAB2_SAVE = 'POST_HRMS32E_DETAIL2_TAB2_SAVE'
export const POST_HRMS32E_DETAIL2_TAB3_SAVE = 'POST_HRMS32E_DETAIL2_TAB3_SAVE'
export const POST_HRMS32E_DETAIL2_TAB4_SAVE = 'POST_HRMS32E_DETAIL2_TAB4_SAVE'
export const POST_HRMS32E_DETAIL2_TAB5_SAVE = 'POST_HRMS32E_DETAIL2_TAB5_SAVE'
export const POST_HRMS32E_DETAIL2_TAB6_SAVE = 'POST_HRMS32E_DETAIL2_TAB6_SAVE'
export const POST_HRMS32E_DETAIL2_TAB7_SAVE = 'POST_HRMS32E_DETAIL2_TAB7_SAVE'
export const POST_HRMS32E_DETAIL3_SAVE = 'POST_HRMS32E_DETAIL3_SAVE'
export const POST_HRMS32E_DETAIL4_SAVE = 'POST_HRMS32E_DETAIL4_SAVE'
export const POST_HRMS32E_DETAIL5_SAVE = 'POST_HRMS32E_DETAIL5_SAVE'
export const POST_HRMS32E_DETAIL6_SAVE = 'POST_HRMS32E_DETAIL6_SAVE'
export const POST_HRMS32E_CANCEL = 'POST_HRMS32E_CANCEL'

export const RECEIVED_HRMS32E_DETAIL_TAB1_CREATE = 'RECEIVED_HRMS32E_DETAIL_TAB1_CREATE'
export const RECEIVED_HRMS32E_DETAIL_TAB2_6_CREATE = 'RECEIVED_HRMS32E_DETAIL_TAB2_6_CREATE'



// WEBPACK FOOTER //
// ./src/store/modules/hrms32e/mutation-types.js